module.exports = __webpack_public_path__ + "img/ararat-reg-bg.1c7a1939.jpg";